'use client'

import { type FC } from 'react'

import { MediServiceFurtherInformation } from '../../../medi-service'
import { RxLpMetas } from '../../components/RxLpMetas'

import { RxLpChFaq } from './components/Faq/RxLpChFaq'
import { RxLpChHero } from './components/Hero/RxLpChHero'
import { RxLpChHowTo } from './components/HowTo/RxLpChHowTo'
import { RxLpChMainForm } from './components/MainForm/RxLpChMainForm'

export const RxChLandingPage: FC = () => {
  return (
    <>
      <RxLpMetas />
      <div className="mx-auto">
        <RxLpChHero />
        <RxLpChHowTo />
        <RxLpChMainForm />
        <RxLpChFaq />
        <MediServiceFurtherInformation className="pb-6 pt-0 tablet:pb-12 tablet:pt-9" />
      </div>
    </>
  )
}
